import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
export const menuItems = [
  {
    id: 0,
    title: <FormattedMessage {...messages.SelectedAnimals} />,
    selectedEartagNumber: null,
  },
  {
    id: 1,
    title: <FormattedMessage {...messages.RegisterLeavingAnimal} />,
    pathOne: (
      <path d="m229.144531 492c0 11.046875-8.957031 20-20.003906 20h-189.140625c-11.046875 0-20-8.953125-20-20v-472c0-11.046875 8.953125-20 20-20h189.144531c11.042969 0 20 8.953125 20 20s-8.953125 20-20 20h-169.144531v432h169.140625c11.046875 0 20.003906 8.953125 20.003906 20zm277.007813-250.144531-113.136719-113.136719c-7.8125-7.808594-20.472656-7.808594-28.285156 0-7.808594 7.8125-7.808594 20.472656 0 28.285156l78.996093 78.996094h-347.722656c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h347.722656l-78.996093 78.992188c-7.808594 7.8125-7.808594 20.476562 0 28.285156 7.8125 7.8125 20.476562 7.808594 28.285156 0l113.140625-113.136719c2.683594-2.675781 4.695312-6.308594 5.472656-10.234375 1.246094-6.292969-.648437-13.226562-5.476562-18.050781zm0 0" />
    ),
    func: 'createReportLeave',
    viewBox: '0 0 600 600',
  },
  {
    id: 2,
    title: <FormattedMessage {...messages.RegisterDeath} />,
    text: '-1',
    func: 'createReportDeath',
    viewBox: '0 0 600 600',
  },
  {
    id: 3,
    title: <FormattedMessage {...messages.CreatePDF} />,
    pathOne: (
      <path
        d="M50.95,12.187l-0.771-0.771L40.084,1.321L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963C7.777,0,6.5,0.916,6.5,2.926V39
		v16.537V56c0,0.837,0.842,1.653,1.838,1.91c0.05,0.013,0.098,0.032,0.15,0.042C8.644,57.983,8.803,58,8.963,58h40.074
		c0.16,0,0.319-0.017,0.475-0.048c0.052-0.01,0.1-0.029,0.15-0.042C50.658,57.653,51.5,56.837,51.5,56v-0.463V39V13.978
		C51.5,13.211,51.408,12.645,50.95,12.187z M47.935,12H39.5V3.565L47.935,12z M8.963,56c-0.071,0-0.135-0.026-0.198-0.049
		C8.609,55.877,8.5,55.721,8.5,55.537V41h41v14.537c0,0.184-0.109,0.339-0.265,0.414C49.172,55.974,49.108,56,49.037,56H8.963z
		 M8.5,39V2.926C8.5,2.709,8.533,2,8.963,2h28.595C37.525,2.126,37.5,2.256,37.5,2.391V14h11.609c0.135,0,0.264-0.025,0.39-0.058
		c0,0.015,0.001,0.021,0.001,0.036V39H8.5z"
      />
    ),
    pathTwo: (
      <path
        d="M22.042,44.744c-0.333-0.273-0.709-0.479-1.128-0.615c-0.419-0.137-0.843-0.205-1.271-0.205h-2.898V54h1.641v-3.637h1.217
		c0.528,0,1.012-0.077,1.449-0.232s0.811-0.374,1.121-0.656c0.31-0.282,0.551-0.631,0.725-1.046c0.173-0.415,0.26-0.877,0.26-1.388
		c0-0.483-0.103-0.918-0.308-1.306S22.375,45.018,22.042,44.744z M21.42,48.073c-0.101,0.278-0.232,0.494-0.396,0.649
		c-0.164,0.155-0.344,0.267-0.54,0.335c-0.196,0.068-0.395,0.103-0.595,0.103h-1.504v-3.992h1.23c0.419,0,0.756,0.066,1.012,0.198
		c0.255,0.132,0.453,0.296,0.595,0.492c0.141,0.196,0.234,0.401,0.28,0.615c0.045,0.214,0.068,0.403,0.068,0.567
    C21.57,47.451,21.52,47.795,21.42,48.073z"
      />
    ),
    pathThree: (
      <path
        d="M31.954,45.4c-0.424-0.446-0.957-0.805-1.6-1.073s-1.388-0.403-2.235-0.403h-3.035V54h3.814
		c0.127,0,0.323-0.016,0.588-0.048c0.264-0.032,0.556-0.104,0.875-0.219c0.319-0.114,0.649-0.285,0.991-0.513
		s0.649-0.54,0.923-0.937s0.499-0.889,0.677-1.477s0.267-1.297,0.267-2.126c0-0.602-0.105-1.188-0.314-1.757
		C32.694,46.355,32.378,45.847,31.954,45.4z M30.758,51.73c-0.492,0.711-1.294,1.066-2.406,1.066h-1.627v-7.629h0.957
		c0.784,0,1.422,0.103,1.914,0.308s0.882,0.474,1.169,0.807s0.48,0.704,0.581,1.114c0.1,0.41,0.15,0.825,0.15,1.244
    C31.496,49.989,31.25,51.02,30.758,51.73z"
      />
    ),
    pathFour: (
      <path
        points="35.598,54 37.266,54 37.266,49.461 41.477,49.461 41.477,48.34 37.266,48.34 37.266,45.168 41.9,45.168 
    41.9,43.924 35.598,43.924 	"
      />
    ),
    pathFive: (
      <path
        d="M38.428,22.961c-0.919,0-2.047,0.12-3.358,0.358c-1.83-1.942-3.74-4.778-5.088-7.562c1.337-5.629,0.668-6.426,0.373-6.802
		c-0.314-0.4-0.757-1.049-1.261-1.049c-0.211,0-0.787,0.096-1.016,0.172c-0.576,0.192-0.886,0.636-1.134,1.215
		c-0.707,1.653,0.263,4.471,1.261,6.643c-0.853,3.393-2.284,7.454-3.788,10.75c-3.79,1.736-5.803,3.441-5.985,5.068
		c-0.066,0.592,0.074,1.461,1.115,2.242c0.285,0.213,0.619,0.326,0.967,0.326h0c0.875,0,1.759-0.67,2.782-2.107
		c0.746-1.048,1.547-2.477,2.383-4.251c2.678-1.171,5.991-2.229,8.828-2.822c1.58,1.517,2.995,2.285,4.211,2.285
		c0.896,0,1.664-0.412,2.22-1.191c0.579-0.811,0.711-1.537,0.39-2.16C40.943,23.327,39.994,22.961,38.428,22.961z M20.536,32.634
		c-0.468-0.359-0.441-0.601-0.431-0.692c0.062-0.556,0.933-1.543,3.07-2.744C21.555,32.19,20.685,32.587,20.536,32.634z
		 M28.736,9.712c0.043-0.014,1.045,1.101,0.096,3.216C27.406,11.469,28.638,9.745,28.736,9.712z M26.669,25.738
		c1.015-2.419,1.959-5.09,2.674-7.564c1.123,2.018,2.472,3.976,3.822,5.544C31.031,24.219,28.759,24.926,26.669,25.738z
		 M39.57,25.259C39.262,25.69,38.594,25.7,38.36,25.7c-0.533,0-0.732-0.317-1.547-0.944c0.672-0.086,1.306-0.108,1.811-0.108
		c0.889,0,1.052,0.131,1.175,0.197C39.777,24.916,39.719,25.05,39.57,25.259z"
      />
    ),
    func: 'createPdf',
    viewBox: '0 0 60 60',
  },
  {
    id: 4,
    title: <FormattedMessage {...messages.MoveToNextBox} />,
    pathOne: (
      <path d="m499.462 0h-378.902c-9.52 0-17.223 7.703-17.223 17.223v51.668h34.446v-34.445h344.456v482.239h-344.456v-34.446h-34.446v51.668c0 9.52 7.703 17.223 17.223 17.223h378.902c9.52 0 17.223-7.703 17.223-17.223v-516.684c0-9.52-7.704-17.223-17.223-17.223z" />
    ),
    pathTwo: (
      <path d="m204.588 366.725 24.354 24.354 115.514-115.514-115.514-115.514-24.354 24.354 73.937 73.937h-244.079v34.446h244.08z" />
    ),
    func: 'confirmMoveAction',
    viewBox: '0 0 600 600',
  },
  {
    id: 5,

    title: <FormattedMessage {...messages.ChangeBox} />,
    pathOne: (
      <path d="m65.689 69.268 8.894 17.788 8.945-17.889-3.528-7.056a39.782 39.782 0 0 0 -35.777-22.111h-44.223v16h44.223a23.868 23.868 0 0 1 21.466 13.268z" />
    ),
    pathTwo: (
      <path d="m165.657 114.343-11.314 11.314 10.343 10.343h-32.909a23.868 23.868 0 0 1 -21.466-13.268l-8.894-17.788-8.945 17.889 3.528 7.056a39.782 39.782 0 0 0 35.777 22.111h32.909l-10.343 10.343 11.314 11.314 24-24a8 8 0 0 0 0-11.314z" />
    ),
    pathThree: (
      <path d="m189.657 42.343-24-24-11.314 11.314 10.343 10.343h-32.909a39.782 39.782 0 0 0 -35.777 22.111l-30.311 60.621a23.868 23.868 0 0 1 -21.466 13.268h-44.223v16h44.223a39.782 39.782 0 0 0 35.777-22.111l30.311-60.621a23.868 23.868 0 0 1 21.466-13.268h32.909l-10.343 10.343 11.314 11.314 24-24a8 8 0 0 0 0-11.314z" />
    ),

    func: 'changeBox',
    viewBox: '0 0 250 250',
  },
  {
    id: 6,
    title: <FormattedMessage {...messages.SyncStockWithHit} />,
    pathOne: (
      <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z" />
    ),
    pathTwo: <path d="M0 0h24v24H0z" fill="none" />,
    func: 'getSynchronize',
    viewBox: '0 0 25 25',
  },
];
